export const customStylesMod = () => ({
    control: (provided) => ({
      ...provided,
      width: 78,
      transition: 'width 0.3s ease',
    }),
    menu: (provided) => ({
      ...provided,
      width: 250,
    }),
  });